const styles = (theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
})

export default styles
